import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";

import { PageInfo } from "../../../../../apis/networkdashboard/graphql/graphql";

@Component({
  selector: "pagination-default",
  templateUrl: "default.html",
  styleUrl: "../../pagination.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class PaginationDefault {
  pageInfo = input.required<PageInfo>();
  prevPage = output();
  nextPage = output();

  protected hasNextPage = computed(() => this.pageInfo().hasNextPage);
  protected hasPreviousPage = computed(() => this.pageInfo().hasPreviousPage);
}
